import {
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
  Snackbar,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Update } from "../../../App";
import CreateIcon from "@mui/icons-material/Create";
import Cookies from "js-cookie";
import AddIcon from "@mui/icons-material/Add";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../components/firebase";
import { motion } from "framer-motion";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const Customize = () => {
  const { setDisplayAppBar } = useContext(Update);
  let d = useRef(),
    data = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [disable, setDisable] = useState(true);
  const workoutname = useRef("");
  const [helperText, setHelperText] = useState();
  const [display1, setDisplay1] = useState("ok");
  const [display2, setDisplay2] = useState("none");
  let a = Cookies.get("_hash");
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="warning"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );
  function getRandomColor(a) {
    let r = 255 - Math.floor(Math.random() * a);
    let b = 255 - Math.floor(Math.random() * a);
    let g = 255 - Math.floor(Math.random() * a);
    return `rgb(${r},${b},${g})`;
  }

  async function getData() {
    try {
      d.current = await getDoc(doc(db, "UserData", a));
      d.current = d.current.data();
    } catch (err) {
      console.log(err);
    }
  }

  async function createWorkout() {
    getData();
    const check = d.current.name.filter((item) => {
      return item === workoutname.current.value;
    });
    if (check.length > 0) {
      handleClick();
    } else {
      async function setCustomizeExercises() {
        await updateDoc(
          doc(db, "UserData", a),
          { ...d.current, [`${workoutname.current.value}`]: [0, 0, 0] },
          { merge: true }
        );
      }
      setCustomizeExercises();
      if (d.current.name === undefined) {
        data.current = [workoutname.current.value];
        try {
          await setDoc(
            doc(db, "UserData", a),
            { name: data.current },
            { merge: true }
          );
          await setDoc(
            doc(db, `${Cookies.get("_hash")}`, `${workoutname.current.value}`),
            { name: "asa" }
          );
        } catch (err) {
          console.log(err);
        }
      } else {
        data.current = [...d.current.name, workoutname.current.value];
        try {
          await updateDoc(
            doc(db, "UserData", a),
            { name: data.current },
            { merge: true }
          );
          await setDoc(
            doc(db, Cookies.get("_hash"), `${workoutname.current.value}`),
            { recentlyAddedList: [] }
          );
        } catch (err) {
          console.log(err);
        }
      }
    }
    setValue(1);
  }

  useEffect(() => {
    if (location.pathname === "/gym/customize") {
      setDisplayAppBar("none");
    }
    async function setData() {
      await getData();
      if (d.current.name !== undefined) {
        setValue(1);
      } else {
        setValue(0);
      }
    }
    setData();
  }, []);
  return (
    <div>
      <Stack direction="row" sx={{ mt: { sm: "10%", lg: "5%" } }}>
        <Typography
          sx={{
            ml: { sm: "8%", lg: "18%" },
            fontWeight: { sm: "400", lg: "700" },
            fontSize: { sm: "35px", lg: "40px" },
          }}
        >
          Customized Workout
        </Typography>
        <Button
        color="warning"
          variant="outlined"
          onClick={() => {
            if (Cookies.get("_hash") === "b229jjcWX9sczZSgE3hL") {
              navigate("/login");
            } else {
              setDisplay2("ok");
              setDisplay1("none");
              setDisable(false);
            }
          }}
          component={motion.button}
          whileHover={{ scale: 1.3, transition: { duration: 0.5 } }}
          sx={{ mt:"1%",ml:"1%",display: display1, fontSize:"small",height:"30px"}}

        >
          <AddIcon fontSize="small"  /> New
        </Button>
        <TextField
          color="error"
          component={motion.div}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.4 }}
          inputRef={workoutname}
          placeholder="Workout Name"
          variant="standard"
          disabled={disable}
          helperText={helperText}
          sx={{ ml: "40px", display: display2, mt: { sm: "1%" } }}
        />

        <Button
          component={motion.button}
          whileHover={{ scale: 1.3 }}
          onClick={() => {
            setDisable(true);
            if (workoutname.current.value === "") {
              setHelperText("TextFiled is empty*");
              setDisable(false);
            } else {
              setHelperText("");
              async function fetchData() {
                await createWorkout();
                setDisplay2("none");
                setDisplay1("ok");
                workoutname.current.value = "";
              }
              fetchData();
            }
          }}
          variant="contained"
          disabled={disable}
          sx={{ display: display2,ml:"1%",fontSize:"small",height:"35px"}}
        >
          Add
        </Button>
      </Stack>
      {value === 0 ? (
        <div>
          <CreateIcon
            sx={{
              color: "grey",
              mt: { sm: "400px", lg: "390px" },
              ml: { sm: "53%", lg: "40%" },
            }}
          />
          <Typography
            sx={{ color: "grey", mt: "1%", ml: { sm: "45%", lg: "36.3%" } }}
          >
            No customized workout
          </Typography>
        </div>
      ) : (
        <Grid
          id="slider"
          container
          direction="row"
          spacing={4}
          sx={{
            ml: { sm: "9%", lg: "19%" },
            width: { sm: "700px", lg: "1000px" },
            overflowY: "scroll",
          }}
        >
          {d.current.name.map((item) => (
            <Grid item xs={6} sm={6.2} md={6} lg={4} xl={4}>
              <Card
                component={motion.div}
                whileHover={{
                  scale: 1.06,
                  boxShadow: "0px 0px 1px 1px grey",
                  cursor: "pointer",
                }}
                Initial={{ y: -100 }}
                animate={{ translateY: 10 }}
                transition={{ duration: 0.3 }}
                onClick={() => {
                  navigate(`/gym/:${item}`);
                }}
              >
                <Box
                  sx={{
                    background: `linear-gradient(to right bottom,${getRandomColor(
                      70
                    )},${getRandomColor(150)})`,
                    width: "inherit",
                    height: "200px",
                    display:"flex",
                    justifyContent:"center",
                    alignItems:"center"
                  }}
                >
                  <Typography
                  sx={{
                    color:"whitesmoke",
                    border: "none",
                    textAlign: "center",
                    fontSize: "24px",
                    fontWeight: "1000",
                  }}
                >
                  {item}
                </Typography>
                </Box>
                <CardContent>
                  <Stack
                    direction="row"
                    sx={{ width: "275px", height: "54px" }}
                  >
                    <span style={{ margin: "0px 15px 0px 25px" }}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontSize: "27px",
                          color: "#222222",
                          fontWeight: "800",
                        }}
                      >
                        {d.current[item][0]}
                      </Typography>
                      <Typography sx={{ fontSize: "15px", color: "grey" }}>
                        Workout
                      </Typography>
                    </span>
                    <span style={{ margin: "0px 0px 0px 25px" }}>
                      <Typography
                        sx={{
                          textAlign: "center",
                          fontSize: "27px",
                          color: "#222222",
                          fontWeight: "800",
                        }}
                      >
                        {d.current[item][1]}
                      </Typography>
                      <Typography sx={{ fontSize: "15px", color: "grey" }}>
                        KCAL
                      </Typography>
                    </span>
                  </Stack>

                  <Button
                    className="gymCardButton"
                    variant="contained"
                    sx={{
                      margin: "-160px 0px 0px 200px",
                      width: "70px",
                      height: "70px",
                      borderRadius: "35px",
                      border: "7px solid #cfd8dc",
                      backgroundColor: "#9e9e9e",
                    }}
                    onClick={() => {
                      navigate(`gym/${workoutname.current.value}`);
                    }}
                  >
                    <PlayArrowIcon
                      sx={{ color: "black", size: "large" }}
                      className="playButton"
                    />
                  </Button>
                </CardContent>

              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="User Already exists!"
        action={action}
      />
    </div>
  );
};

export default Customize;
